import isFunction from 'lodash/isFunction'
import find from 'lodash/find'

export const useCommunicationTemplateVariableReplace = () => {
  const execute = async (template, data) => {
    const promises = []

    template.replace(/{{(.*?)}}/g, (match) => {
      const fieldName = match.split(/{{|}}/).filter(Boolean)[0]
      const matchValue = data[fieldName]

      if (isFunction(matchValue)) {
        promises.push(matchValue().then((resp) => [fieldName, resp]))
      } else promises.push([fieldName, matchValue])
    })

    const results = await Promise.all(promises)

    return template.replace(/{{(.*?)}}/g, (match) => {
      const fieldName = match.split(/{{|}}/).filter(Boolean)[0]
      const matchValue = find(results, (item) => {
        return item?.[0] === fieldName
      })

      //return empty string if the match value is undefined so it will not write undefined on the chat message input
      return matchValue?.[1] ?? ''
    });
  }
  return { execute }
}
